<template>
      <div id="important-contacts">
            <section class="section contacts-hero animate__animated animate__fadeIn">
                  <BackButton link="/intro" />
                  <div class="grid-container max">
                        <div class="contacts-grid">
                              <div class="contacts-left">
                                    <h1>Important<br />contact<br />information</h1>
                              </div>
                              <div class="contacts-right">
                                    <div class="contacts-section">
                                          <div class="contacts-section-header">Anthem contact information</div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Anthem Blue Cross and Blue Shield (Anthem)</p>
                                                <p class="contacts-detail">855-641-4862<br />8 a.m. to 8 p.m. ET, Monday &ndash; Friday<br /><a href="https://www.anthem.com/shbp/" target="_blank" @click="track('Link', 'anthem.com/shbp - Important Contacts')">anthem.com/shbp</a></p>
                                                <p class="contacts-desc">Call our Member Services line or visit our website to find answers to your benefit questions, check your HRA or MIA credit balance or get detailed information about your plan.</p>
                                          </div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Anthem 24/7 NurseLine</p>
                                                <p class="contacts-detail">866-787-6361<br />24 hours a day/7 days a week</p>
                                                <p class="contacts-desc">Registered nurses can answer your health questions any time of the day or night.</p>
                                          </div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Total Health, Total You with Anthem</p>
                                                <p class="contacts-detail">866-901-0746<br />8 a.m. to 6 p.m. ET, Monday &ndash; Friday</p>
                                                <ul class="contacts-desc-list">
                                                      <li>Telephonic access to clinical health experts</li>
                                                      <li>Co-Pay/Co-Insurance Waiver Program</li>
                                                      <li>Building Healthy Families</li>
                                                </ul>
                                          </div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Anthem Behavioral Health Resource Center</p>
                                                <p class="contacts-detail">855-679-5722<br />24 hours a day/7 days a week</p>
                                                <p class="contacts-desc">Depression, bipolar disorder, alcohol/drug abuse, anxiety disorders, eating disorders</p>
                                          </div>
                                    </div>

                                    <div class="contacts-section">
                                          <div class="contacts-section-header">Wellness contact information</div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Be Well SHBP&reg; well-being program, administered by Sharecare</p>
                                                <p class="contacts-detail">888-616-6411<br />8 a.m. to 8 p.m. ET, Monday &ndash; Friday<br /><a href="https://bewellshbp.com" target="_blank" @click="track('Link', 'bewellshbp.com - Important Contacts')">bewellshbp.com</a></p>
                                                <ul class="contacts-desc-list">
                                                      <li>Complete well-being incentive actions</li>
                                                      <li>Help with improving health through lifestyle changes</li>
                                                </ul>
                                          </div>
                                    </div>

                                    <div class="contacts-section">
                                          <div class="contacts-section-header">Pharmacy contact information</div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">Express Scripts, Inc</p>
                                                <p class="contacts-detail">800-809-8593<br />24 hours per day/7 days per week<br /><a href="https://www.express-scripts.com/shbp" target="_blank" @click="track('Link', 'express-scripts.com/shbp - Important Contacts')">www.express-scripts.com/shbp</a></p>
                                                <ul class="contacts-desc-list">
                                                      <li>Specially-trained pharmacists are available to talk 24/7</li>
                                                      <li>Can help you locate a retail pharmacy or get your prescriptions delivered to your door</li>
                                                </ul>
                                          </div>
                                    </div>

                                    <div class="contacts-section">
                                          <div class="contacts-section-header">Enrollment and eligibility contact information</div>
                                          <div class="contacts-row">
                                                <p class="contacts-name">SHBP Member Services</p>
                                                <p class="contacts-detail">800-610-1863<br />8:30 a.m. to 5 p.m. ET, Monday &ndash; Friday<br /><a href="https://www.shbp.georgia.gov" target="_blank" @click="track('Link', 'shbp.georgia.gov - Important Contacts')">www.shbp.georgia.gov</a></p>
                                                <p class="contacts-desc">Questions about eligibility, premiums, or enrollment.</p>
                                          </div>
                                    </div>

                                    <p class="contacts-disclaimer">Anthem Blue Cross and Blue Shield is the trade name of Blue Cross Blue Shield Healthcare Plan of Georgia, Inc. Independent licensee of the Blue Cross and Blue Shield Association. ANTHEM is a registered trademark of Anthem Insurance Companies, Inc.</p>

                                    <router-link to="/intro" class="contacts-return-link">Return to guide</router-link>
                              </div>
                        </div>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPImportantContacts",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#important-contacts {
      .contacts-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;

            .back-btn {
                  left: 86px;
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .contacts-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 100px;
                  margin-top: 48px;
            }

            .contacts-left {
                  flex: 1 1 360px;
                  max-width: 420px;
                  position: sticky;
                  top: 140px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .contacts-right {
                  flex: 2 1 640px;
                  max-width: 900px;
                  min-width: 0;
            }

            .contacts-section {
                  margin-bottom: 40px;

                  &:last-of-type {
                        margin-bottom: 0;
                  }
            }

            .contacts-section-header {
                  background-color: #1355E9;
                  color: #ffffff;
                  font-weight: 700;
                  font-size: 1rem;
                  padding: 14px 20px;
                  margin-bottom: 24px;
            }

            .contacts-row {
                  display: grid;
                  grid-template-columns: minmax(0, 200px) minmax(0, 200px) minmax(0, 1fr);
                  gap: 20px;
                  margin-bottom: 32px;

                  &:last-child {
                        margin-bottom: 0;
                  }
            }

            .contacts-name {
                  color: #002E58;
                  font-weight: 700;
                  font-size: 1rem;
                  line-height: 1.4;
                  margin-bottom: 0;
            }

            .contacts-detail {
                  color: #12130f;
                  font-size: 0.9375rem;
                  line-height: 1.6;
                  margin-bottom: 0;

                  a {
                        color: #1355E9 !important;
                        text-decoration: underline;
                  }
            }

            .contacts-desc {
                  color: #3F3A4E;
                  font-size: 0.9375rem;
                  line-height: 1.6;
                  margin-bottom: 0;
            }

            .contacts-desc-list {
                  margin: 0;
                  padding: 0 0 0 1.125rem;

                  li {
                        color: #3F3A4E;
                        font-size: 0.9375rem;
                        line-height: 1.6;
                        margin-bottom: 4px;

                        &:last-child {
                              margin-bottom: 0;
                        }
                  }
            }

            .contacts-disclaimer {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 24px;
            }

            .contacts-return-link {
                  display: inline-block;
                  color: #1355E9 !important;
                  font-weight: 700;
                  font-size: 1.125rem;
                  position: relative;
                  padding-left: 24px;

                  &:before {
                        content: "";
                        background-image: url("~@/assets/img/arrow-left-icon.png");
                        filter: brightness(0) saturate(100%) invert(23%) sepia(84%) saturate(2476%) hue-rotate(216deg) brightness(97%) contrast(96%);
                        background-size: 15px 13px;
                        width: 15px;
                        height: 13px;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 80px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .contacts-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .contacts-left {
                        max-width: 100%;
                        position: static;

                        h1 {
                              font-size: clamp(2rem, 9vw, 3rem) !important;
                        }
                  }

                  .contacts-right {
                        max-width: 100%;
                  }

                  .contacts-row {
                        grid-template-columns: 1fr;
                        gap: 8px;
                  }
            }
      }
}
</style>
